var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-widget widget",attrs:{"id":"add-widget"}},[_c('div',{staticStyle:{"height":"100%"},domProps:{"innerHTML":_vm._s(_vm.html_content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }